import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import AuthContext from "../../contexts/AuthContext";
import { useToast } from "../../design-system/contexts/ToastContext";
import { setJwtToken } from "../../axios";
import { isValidEmail, parseAuthError } from "../../utils/validation";

// Auth Components
import { AuthLayout, BackHeader, OTPInput } from "./components";
import "./Auth.css";

const OtpRegistration = () => {
  const { success, error: showError } = useToast();
  const query = new URLSearchParams(window.location.search);
  const domain = query.get("redirect");

  const { setValue } = useContext(AuthContext);
  const { setEventUpdate } = useContext(AuthContext);

  const navigate = useNavigate();
  const location = useLocation();

  const [state, setState] = useState({
    data: {
      email: "",
      inputOtp: "",
    },
    receivedOtp: false,
    loading: false,
    errors: {
      email: "",
      inputOtp: "",
    },
    redirect: "",
  });

  const [user, setUser] = useState(null);
  const [counter, setCounter] = useState(30);

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [state.receivedOtp && counter]);

  const doValidate = () => {
    if (state.data.email === undefined || state.data.email === "") {
      setState({
        ...state,
        errors: {
          ...state.errors,
          email: "Please enter your email",
        },
      });
      return false;
    }

    // Use improved email validation
    if (!isValidEmail(state.data.email)) {
      setState({
        ...state,
        errors: {
          ...state.errors,
          email: "Please enter a valid email address",
        },
      });
      return false;
    }

    return true;
  };

  const validateOtp = () => {
    if (!state.data.inputOtp || state.data.inputOtp === "") {
      setState({
        ...state,
        errors: {
          ...state.errors,
          inputOtp: "Please enter OTP",
        },
      });
      return false;
    }
    if (state.data.inputOtp.length !== 6) {
      setState({
        ...state,
        errors: {
          ...state.errors,
          inputOtp: "Please enter complete OTP",
        },
      });
      return false;
    }
    return true;
  };

  const specials = "!@#$%^&*()_+{}:\"<>?|[];',./`~";
  const lowercase = "abcdefghijklmnopqrstuvwxyz";
  const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const numbers = "0123456789";

  function pick(exclusions, string, min, max) {
    let chars = "";
    let i = 0;
    while (i < max) {
      const character = string.charAt(
        Math.floor(Math.random() * string.length)
      );
      if (exclusions.indexOf(character) < 0 && chars.indexOf(character) < 0) {
        chars += character;
        i++;
      }
    }
    return chars;
  }

  const all = specials + lowercase + uppercase + numbers;

  function generateRandomPass() {
    let password = "";
    password += pick(password, specials, 1, 3);
    password += pick(password, lowercase, 1, 3);
    password += pick(password, uppercase, 1, 3);
    password += pick(password, numbers, 1, 3);
    password += pick(password, all, 10);
    return password;
  }

  const requestOtp = async () => {
    setState({ ...state, loading: true });
    if (doValidate()) {
      if (location.state.signUp) {
        if (state.receivedOtp) {
          try {
            const response = await Auth.resendSignUp(state.data.email);
            console.log(response);
            setUser(response.user);
            setState({ ...state, loading: false, receivedOtp: true });
            success("OTP sent successfully");
          } catch (err) {
            let error = parseAuthError(err);
            showError(error);
            console.log(error);
            setState({ ...state, loading: false, receivedOtp: false });
          }
        } else {
          try {
            const response = await Auth.signUp({
              username: state.data.email,
              password: generateRandomPass(),
              attributes: {
                name: state.data.email,
              },
            });

            console.log(response);
            setUser(response.user);
            setState({ ...state, loading: false, receivedOtp: true });
            success("OTP sent successfully");
          } catch (err) {
            let error = parseAuthError(err);
            if (error.includes("already exists")) {
              try {
                const response = await Auth.resendSignUp(state.data.email);
                console.log(response);
                setState({ ...state, loading: false, receivedOtp: true });
                success("OTP sent successfully");
              } catch (err) {
                let errorMsg = parseAuthError(err);
                showError(errorMsg);
                console.log(errorMsg);
                setState({ ...state, loading: false, receivedOtp: false });
              }
            } else {
              showError(error);
              setState({ ...state, loading: false, receivedOtp: false });
            }
            console.log(state);
          }
        }
      } else {
        try {
          const response = await Auth.signIn(state.data.email);
          console.log(response);
          setUser(response);
          setState({ ...state, loading: false, receivedOtp: true });
          success("OTP sent successfully");
        } catch (err) {
          let error = err.message || "Something went wrong!";
          showError(error);
          console.log(error);
          setState({ ...state, loading: false, receivedOtp: false });
        }
      }
    }
  };

  const verifyOtp = async () => {
    if (validateOtp()) {
      setState({ ...state, loading: true });
      if (location.state.signUp) {
        try {
          const cognitoUser = await Auth.confirmSignUp(
            state.data.email,
            state.data.inputOtp
          );
          if (cognitoUser) {
            success("Account verification successful. You can login to your account now");
            navigate(`/login`);
          }
        } catch (err) {
          let error = parseAuthError(err);
          showError(error);
          console.log(error);
          setState({ ...state, loading: false, receivedOtp: false });
        }
      } else {
        try {
          const cognitoUser = await Auth.sendCustomChallengeAnswer(
            user,
            state.data.inputOtp
          );
          setState({ ...state, loading: false, receivedOtp: true });
          if(!cognitoUser.signInUserSession){
            let error = "OTP is invalid"
            showError(error);
          }
          else{
            setJwtToken(cognitoUser.signInUserSession.idToken.jwtToken);
            success("Signed in successfully!");
            navigate(0);
          }
        } catch (err) {
          setState({
            ...state,
            data: { ...state.data, inputOtp: "" },
            loading: false,
            receivedOtp: true
          });

          let error = parseAuthError(err);
          showError(error);
          console.log(error);
        }
      }
    }
  };

  useEffect(() => {
    if (!location.state) {
      navigate(`/login`);
    }
  }, []);

  const handleSubmit = () => {
    if (state.receivedOtp) {
      verifyOtp();
    } else {
      requestOtp();
    }
  };

  const handlePressEnter = (e) => {
    if (e.keyCode === 13) {
      handleSubmit();
    }
  };

  const handleResendOtp = () => {
    if (counter === 0) {
      setCounter(30);
      requestOtp();
    }
  };

  // Show OTP verification screen
  if (state.receivedOtp) {
    return (
      <AuthLayout>
        <BackHeader
          title="Enter OTP"
          onBack={() => setState({ ...state, receivedOtp: false, data: { ...state.data, inputOtp: "" } })}
        />

        <p className="auth-description">
          Please enter the OTP we have sent you on {state.data.email}
        </p>

        <div style={{ marginBottom: "var(--spacing-4)" }}>
          <label className="auth-form__label" style={{ marginBottom: "var(--spacing-2)", display: "block" }}>OTP</label>
          <OTPInput
            value={state.data.inputOtp}
            onChange={(otp) => {
              setState({
                ...state,
                data: { ...state.data, inputOtp: otp },
                errors: { ...state.errors, inputOtp: "" },
              });
            }}
            numInputs={6}
            error={state.errors.inputOtp}
          />
        </div>

        <p className="auth-resend">
          Didn't receive an OTP?{" "}
          <span
            className={`auth-resend__link ${counter !== 0 ? "auth-resend__link--disabled" : ""}`}
            onClick={handleResendOtp}
          >
            Resend OTP {counter !== 0 ? `in ${counter} seconds` : ""}
          </span>
        </p>

        <button
          className="auth-btn"
          onClick={handleSubmit}
          disabled={state.loading}
          style={{ marginTop: "var(--spacing-4)" }}
        >
          {state.loading ? <span className="auth-spinner"></span> : (location.state?.signUp ? "Sign Up" : "Sign In")}
        </button>
      </AuthLayout>
    );
  }

  // Show Request OTP screen
  return (
    <AuthLayout>
      <BackHeader
        title={location.state?.signUp ? "Sign Up with OTP" : "Sign In with OTP"}
        onBack={() => navigate("/login")}
      />

      <p className="auth-description">
        A one-time password will be sent to the following Email ID.
      </p>

      {/* Email Input */}
      <div className="auth-form__group">
        <label className="auth-form__label">Email</label>
        <input
          type="email"
          className={`auth-form__input ${state.errors.email ? "auth-form__input--error" : ""}`}
          placeholder="Johnd@konfhub.com"
          value={state.data.email}
          onKeyDown={handlePressEnter}
          onChange={(e) => {
            setState({
              ...state,
              data: { ...state.data, email: e.target.value.toLowerCase() },
              errors: { ...state.errors, email: "" },
            });
          }}
          onBlur={() => {
            if (state.data.email === undefined || state.data.email === "") {
              setState({
                ...state,
                errors: { ...state.errors, email: "Please enter your email" },
              });
            } else if (!isValidEmail(state.data.email)) {
              setState({
                ...state,
                errors: { ...state.errors, email: "Please enter a valid email address" },
              });
            }
          }}
        />
        {state.errors.email && (
          <span className="auth-form__error">{state.errors.email}</span>
        )}
      </div>

      {/* Request OTP Button */}
      <button
        className="auth-btn"
        onClick={handleSubmit}
        disabled={state.loading}
        style={{ marginTop: "var(--spacing-6)" }}
      >
        {state.loading ? <span className="auth-spinner"></span> : "Request OTP"}
      </button>
    </AuthLayout>
  );
};

export default OtpRegistration;
